const geoLocationMaxAge = 1000 * 60 * 60; // 1 hour
export const GEOLOCATION_KEY = '_sklz_lc';

export function getCurrentPosition(): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    const successes: PositionCallback = (position) => {
      localStorage.setItem(GEOLOCATION_KEY, btoa(JSON.stringify(position)));
      resolve(position);
    };

    const error: PositionErrorCallback = (positionError) => {
      console.log('GEO: Error getting location', positionError);
      reject(positionError);
    };

    const options = {
      timeout: 1000 * 20,
      maximumAge: geoLocationMaxAge,
      enableHighAccuracy: false,
    };

    navigator.geolocation.getCurrentPosition(successes, error, options);
  });
}
